import { createContext } from 'react';
const queueContext = createContext();
export default queueContext;
